import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { usePlacesWidget } from "react-google-autocomplete";
import config from "../../js/config";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        "& .pac-container": {
            top: "50px !important",
            left: "0 !important",
        },
    },
});

function GoogleAutoCompleteField(props) {
    const { onPlaceSelected, ...rest } = props;
    const classes = useStyles();
    const { ref: placesRef } = usePlacesWidget({
        apiKey: config.paymentcloud.GOOGLE_API_KEY,
        onPlaceSelected,
        options: {
            types: ["geocode"],
            componentRestrictions: { country: ["us", "ca"] },
        },
    });

    useEffect(() => {
        // Google Autocomplete Widget Pop-Up/Dropdown Container
        const element = document.querySelector(".pac-container");

        if (element) {
            document
                .getElementById("address_autocomplete_section")
                .appendChild(element);
        }
    }, [rest.value]);

    return (
        <Form.Group
            size="lg"
            id="address_autocomplete_section"
            className={classes.root}
        >
            <Form.Control ref={placesRef} {...rest} />
            <Form.Label className="floating-label">
                {rest.placeholder}
            </Form.Label>
        </Form.Group>
    );
}

export default GoogleAutoCompleteField;
